import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        lng: navigator.language && navigator.language.substr(0, 2),
        debug: false,
        backend: {
            loadPath: "https://translations.piggy.eu/business-dashboard/{{lng}}.json",
        },
        interpolation: {
            escapeValue: false,
        },
    });